import { LoginCredentials, User } from '../../../types/auth.types';
import { api } from '../axios.interceptor';
import { API_ENDPOINTS } from '../constants';

export const authApi = {
  // Public endpoints
  login: async (credentials: LoginCredentials) => {
    const response: any = await api.post<{
      user: any;
      tokens: any;
    }>(API_ENDPOINTS.AUTH.LOGIN, credentials);
    return response.data;
  },

  register: async (userData: {
    username: string;
    email: string;
    password: string;
  }) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  forgotPassword: async (email: string) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string) => {
    const response = await api.post('/auth/reset-password', {
      token,
      newPassword,
    });
    return response.data;
  },

  verifyEmail: async (token: string) => {
    const response = await api.post('/auth/verify-email', { token });
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get<User>('/auth/profile');
    return response.data;
  },

  updateProfile: async (data: Partial<User>) => {
    const response = await api.put('/auth/profile', data);
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

};


// This function will be called by the modal to get a new token.
// IMPORTANT: Use a separate, un-intercepted Axios instance or configure the 
// interceptor to ignore this specific URL to avoid an infinite loop if the refresh call itself returns 401.
// For simplicity here, we assume the main 'api' instance is configured correctly.
export const refreshToken = async (): Promise<void> => {
  // Replace with your actual refresh token endpoint and logic
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token available.');
  }

  const response = await api.post(API_ENDPOINTS.AUTH.REFRESH, { refreshToken });

  console.log({ response });

  // Assuming the response contains a new accessToken
  const newAccessToken = response.data.accessToken;
  if (!newAccessToken) {
    throw new Error('Failed to get new access token from refresh endpoint.');
  }

  localStorage.setItem('accessToken', newAccessToken);

  // Update the default Authorization header on the axios instance
  api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
};

// This function clears session data and redirects.
export const logout = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  // any other cleanup

  // Redirect to login page
  window.location.replace('/auth/login'); // Use .replace() to prevent going back
};